import { gql }  from '@apollo/client';

const CREATE_PREFERRED_LAB_VENDOR = gql`
  mutation ($memberId: ID!, $labVendorId: ID!) {
    createPreferredLabVendor(memberId: $memberId, labVendorId: $labVendorId) {
      success
    }
  }
`;

export default CREATE_PREFERRED_LAB_VENDOR;
